<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="MainGrid2Col">
	<label>Student ID:</label>
	<label>{{ StudentID }}</label>

	<label>Student Name:</label>
	<label>{{ StudentName }}</label>

	<label>Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="LogDate" name="LogDate"></p-calendar>

	<label>Time:</label>
	<p-calendar showTime="true" timeOnly="true" hourFormat="12" showIcon="true" showButtonBar="true" [(ngModel)]="LogTime" name="LogTime"></p-calendar>

	<label>Comments:</label>
	<textarea [(ngModel)]="Comments" rows="5" class="TextArea"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
